import service from './service'

// preset modals
// import ConfirmModal from '@/modals/ConfirmModal.vue'

export default {
    install(Vue) {
        Vue.prototype.$modal = {
            // generic
            open: service.open,

            // presets
            // confirm({ title = 'Xác nhận', message = '', okText = 'OK', cancelText = 'Hủy', input = null, options = {} } = {}) {
            //     return service.open(ConfirmModal, {
            //         props: { title, message, okText, cancelText },
            //         input,
            //         options
            //     })
            // },

            // advanced controls
            _resolve: service.requestResolve,
            _reject: service.requestReject,
            clear: service.clear,
            _state: service.state
        }
    }
}